import { t } from "@/mixins/i18nMixin";
import { STORE } from "@/store";
import { Router } from "@uuip/unified-ui-platform";
import { html } from "lit-html";
import style from "./EvaluationsManagerBlock.scss";
const EvaluationsManagerBlock = () => {
    return new Router.RouterView.Block({
        template: html `
      <div class="evaluations-manager-view">
        <agentx-wc-panel-frame heading="${t("app:qmw.evaluationsManager")}">
          <agentx-wc-evaluation-manager-table .isDarkMode=${STORE.app.darkMode}></agentx-wc-evaluation-manager-table>
        </agentx-wc-panel-frame>
      </div>
    `,
        styles: [style]
    });
};
export default EvaluationsManagerBlock;
